import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectedPresaleSeriesChild, unlockedSelectedPresaleSeriesChild } from '../../series/selectors/eventSeries';
import EmbedFooter from '../../../components/EmbedFooter';
import { isDynamicListing } from '@b/checkout/selectors/dynamic-listing';

class InventoryFooterContainer extends Component {

    render() {
        if (this.props.selectedPresaleSeriesChild && !this.props.unlockedSelectedPresaleSeriesChild) {
            return <div className='event-inventory__footer empty' />;
        }

        return (
          <div className='event-inventory__footer-wrap'>
            <div className='event-inventory__footer'>
              {this.props.children}
              {!this.props.isDynamic && (<EmbedFooter />)}
            </div>
          </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        selectedPresaleSeriesChild: selectedPresaleSeriesChild(state),
        unlockedSelectedPresaleSeriesChild: unlockedSelectedPresaleSeriesChild(state),
        isDynamic: isDynamicListing(state),
    }
}

export default connect(mapStateToProps)(InventoryFooterContainer)
